// src/components/FormSections/FormSectionAcademico.js

import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Row, Col } from "reactstrap"
import FormikInput from "../Common/Formik/FormikInput"
import FormikDatePicker from "../Common/Formik/FormikDatePicker"
import FormikSelect from "../Common/Formik/FormikSelect"

// #region selectors
import {
  useCampusVirtualIdCampus,
  useCampusVirtualListaCampusActivosDisplay,
  useCampusVirtualOptionsListaCampus,
  useCampusVirtualOptionsListaProgramasAcademicos,
  useCampusVirtualOptionsListaPlanesEstudio,
  useCampusVirtualOptionsListaTurnos,
  useCampusVirtualOptionsListaTrayectorias,
  useCampusVirtualOptionsListaStatus,
  useCampusVirtualGetidNivelEducativoxidPlanEstudioInPlanesLight,
  useCargosCostoInscripcion,
  useCargosCostoColegiatura,
  useControlEscolarDescuentosInscripcion,
} from "store/selectors"
// #endregion

// #region actions
import {
  getCampusVirtualCampus,
  getCampusVirtualCarreras,
  getCampusVirtualPlanes,
  getCampusVirtualTurnos,
  getCampusVirtualTrayectorias,
  getCampusVirtualStatus,
  getCargosCostoInscripcion,
  getCargosCostoColegiatura,
} from "../../store/actions"
// #endregion

const FormSectionAcademico = ({
  formik,
  handleUpperCaseChange,
  handleLowerCaseChange,
  resetForm,
}) => {
  //
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region const-selectors
  const idCampusCurrent = useCampusVirtualIdCampus()
  const listaCampus = useCampusVirtualListaCampusActivosDisplay()
  const optionsCampus = useCampusVirtualOptionsListaCampus()
  const optionsProgramasAcademicos =
    useCampusVirtualOptionsListaProgramasAcademicos()
  const optionsPlanesEstudio = useCampusVirtualOptionsListaPlanesEstudio()
  const optionsTurnos = useCampusVirtualOptionsListaTurnos()
  const optionsTrayectorias = useCampusVirtualOptionsListaTrayectorias()
  const optionsStatus = useCampusVirtualOptionsListaStatus()
  const idNivelEducativo =
    useCampusVirtualGetidNivelEducativoxidPlanEstudioInPlanesLight(
      formik.values["id_Plan_Estudio"]
    )
  const costoInscripcion = useCargosCostoInscripcion()
  const costoColegiatura = useCargosCostoColegiatura()
  // #endregion

  // #region Internal States
  // #endregion

  // #region useEffects
  //
  // lista campus
  useEffect(() => {
    //console.log("Montando el componente: FormSectionAcademico")
    //console.log("optionsCampus.length: ", optionsCampus.length)
    if (optionsCampus.length === 0) {
      //console.log("dispatching : getCampusVirtualCampus")
      dispatch(
        getCampusVirtualCampus({
          nombreSolicitud: "getarbollistacampi",
        })
      )
    }
    //console.log("optionsStatus.length: ", optionsStatus.length)
    if (optionsStatus.length === 0) {
      //console.log("dispatching: getCampusVirtualStatus")
      dispatch(
        getCampusVirtualStatus({
          nombreSolicitud: "getlistaStatus",
        })
      )
    }
  }, [])

  useEffect(() => {
    //console.log("Cambió: formik.values[id_Campus]")
    //console.log("id_Campus: ", formik.values["id_Campus"])

    formik.setFieldValue("id_Programa_Academico", -1)
    formik.setFieldValue("id_Plan_Estudio", -1)
    formik.setFieldValue("id_Trayectoria", -1)
    formik.setFieldValue("id_Turno", -1)

    if (formik.values["id_Campus"] > 0) {
      dispatch(
        getCampusVirtualCarreras({
          nombreSolicitud: "getarbolprogramasacademicosxidcampus",
          idCampus: formik.values["id_Campus"],
        })
      )
    }
  }, [formik.values["id_Campus"], dispatch])

  useEffect(() => {
    //console.log("Cambió: formik.values[id_Programa_Academico]")
    //console.log(
    "id_Programa_Academico: ", formik.values["id_Programa_Academico"]
    //)
    formik.setFieldValue("id_Plan_Estudio", -1)
    formik.setFieldValue("id_Trayectoria", -1)
    formik.setFieldValue("id_Turno", -1)

    if (
      formik.values["id_Campus"] > 0 &&
      formik.values["id_Programa_Academico"] > 0
    ) {
      dispatch(
        getCampusVirtualPlanes({
          nombreSolicitud: "getarbolplanesestudioxidcampus",
          idCampus: formik.values["id_Campus"],
          idProgramaAcademico: formik.values["id_Programa_Academico"],
        })
      )
    }
  }, [formik.values["id_Programa_Academico"], dispatch])

  useEffect(() => {
    //console.log("Cambió: formik.values[id_Plan_Estudio]")
    //console.log("id_Plan_Estudio: ", formik.values["id_Plan_Estudio"])

    formik.setFieldValue("id_Trayectoria", -1)
    formik.setFieldValue("id_Turno", -1)
    if (
      formik.values["id_Campus"] > 0 &&
      formik.values["id_Plan_Estudio"] > 0
    ) {
      dispatch(
        getCampusVirtualTurnos({
          nombreSolicitud: "getarbolturnosxidcampusxidplanestudio",
          idCampus: formik.values["id_Campus"],
          idPlanEstudio: formik.values["id_Plan_Estudio"],
        })
      )
      //console.log("dispatching: getCampusVirtualTrayectorias")
      dispatch(
        getCampusVirtualTrayectorias({
          nombreSolicitud: "getarboltrayectoriaxdcampusxidplanestudio",
          idCampus: formik.values["id_Campus"],
          idPlanEstudio: formik.values["id_Plan_Estudio"],
        })
      )
      // Consigo el id_Nivel_Educativo del contexto de CampusVirtual
      // PlanesLight
      if (idNivelEducativo) {
        //console.log("idNivelEducativo: ", idNivelEducativo)
        formik.setFieldValue("id_Nivel_Educativo", idNivelEducativo)
      }

      formik.setFieldValue(
        "Nombre_Plan_Estudio",
        optionsPlanesEstudio.find(
          op => op.value === formik.values["id_Plan_Estudio"]
        )?.label || "No encontrado"
      )
    }
  }, [formik.values["id_Plan_Estudio"], dispatch])

  useEffect(() => {
    //console.log("Cambió: formik.values[id_Turno]")
    //console.log("id_Turno: ", formik.values["id_Turno"])

    if (
      formik.values["id_Campus"] > 0 &&
      formik.values["id_Plan_Estudio"] > 0 &&
      formik.values["id_Turno"] > 0 &&
      idNivelEducativo > 0
    ) {
      dispatch(
        getCargosCostoInscripcion({
          nombreSolicitud: "getcostoxinscripcion",
          id_Campus: formik.values["id_Campus"],
          id_Plan_Estudio: formik.values["id_Plan_Estudio"],
          id_Turno: formik.values["id_Turno"],
          id_Nivel_Educativo: formik.values["id_Nivel_Educativo"],
        })
      )
      dispatch(
        getCargosCostoColegiatura({
          nombreSolicitud: "getcostoxcolegiatura",
          id_Campus: formik.values["id_Campus"],
          id_Plan_Estudio: formik.values["id_Plan_Estudio"],
          id_Turno: formik.values["id_Turno"],
          id_Nivel_Educativo: formik.values["id_Nivel_Educativo"],
        })
      )

      formik.setFieldValue(
        "Nombre_Turno",
        optionsTurnos.find(op => op.value === formik.values["id_Turno"])
          ?.label || "No encontrado"
      )
    }
  }, [formik.values["id_Turno"], dispatch])

  useEffect(() => {
    if (costoInscripcion && costoInscripcion.hasOwnProperty("Costo")) {
      //console.log("Cambió: costoInscripcion")
      //console.log("costoInscripcion: ", costoInscripcion.Costo)
      formik.setFieldValue("Importe_Inscripcion", costoInscripcion.Costo)
      formik.setFieldValue("Inscripcion", costoInscripcion.Costo)
    }
  }, [costoInscripcion])

  useEffect(() => {
    if (costoColegiatura && costoColegiatura.hasOwnProperty("Costo")) {
      //console.log("Cambió: costoColegiatura")
      //console.log("costoColegiatura: ", costoColegiatura.Costo)
      formik.setFieldValue("Importe_Colegiatura", costoColegiatura.Costo)
      formik.setFieldValue("Colegiatura", costoColegiatura.Costo)
    }
  }, [costoColegiatura])

  // #endregion

  // #region Funciones

  // #endregion

  return (
    <>
      {/* Sección de Académico */}
      <h5 className="mb-4">Académico</h5>
      {/* Campus, Programa Académico, Plan Estudio */}
      <Row>
        {/* Campus */}
        <Col md={4}>
          <div className="mb-3">
            <FormikSelect
              label="* Campus"
              name="id_Campus"
              options={optionsCampus || []}
              formik={formik}
              placeholder="Selecciona Campus"
              valuePlaceHolder={-1}
            />
          </div>
        </Col>
        {/* Programa Académico */}
        <Col md={4}>
          <div className="mb-3">
            <FormikSelect
              label="* Programa Académico"
              name="id_Programa_Academico"
              options={optionsProgramasAcademicos || []}
              formik={formik}
              placeholder="Selecciona Carrera"
              valuePlaceHolder={-1}
            />
          </div>
        </Col>
        {/* Plan Estudio */}
        <Col md={4}>
          <div className="mb-3">
            <FormikSelect
              label="* Plan Estudio"
              name="id_Plan_Estudio"
              options={optionsPlanesEstudio || []}
              formik={formik}
              placeholder="Selecciona Plan de Estudio"
              valuePlaceHolder={-1}
            />
          </div>
        </Col>
      </Row>

      {/* Trayectoria, Turno, Turno Extra */}
      <Row>
        {/* Trayectoria */}
        <Col md={4}>
          <div className="mb-3">
            <FormikSelect
              label="* Trayectoria"
              name="id_Trayectoria"
              options={optionsTrayectorias || []}
              formik={formik}
              placeholder="Selecciona Trayectoria"
              valuePlaceHolder={-1}
            />
          </div>
        </Col>
        {/* Turno */}
        <Col md={4}>
          <div className="mb-3">
            <FormikSelect
              label="* Turno"
              name="id_Turno"
              options={optionsTurnos || []}
              formik={formik}
              placeholder="Selecciona Turno"
              valuePlaceHolder={-1}
            />
          </div>
        </Col>
        {/* Turno Extra */}
        <Col md={4}>
          <div className="mb-3">
            {/* <FormikSelect
              label="* Turno Extra"
              name="id_Turno_Extra"
              options={optionsTurnos || []}
              formik={formik}
              placeholder="Selecciona Turno Extra"
              valuePlaceHolder={-1}
            /> */}
          </div>
        </Col>
      </Row>

      {/* id_Status, Grupo, Matricula SE, Generación */}
      <Row>
        {/* id_Status */}
        <Col md={3}>
          <div className="mb-3">
            <FormikSelect
              label="* Status"
              name="id_Status"
              options={optionsStatus || []}
              formik={formik}
              placeholder="Selecciona Status"
              valuePlaceHolder={-1}
            />
          </div>
        </Col>
        {/* Grupo */}
        <Col md={3}>
          <div className="mb-3">
            <FormikInput
              label="* Grupo"
              name="Grupo"
              placeholder="Grupo"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        {/* Matricula SE */}
        <Col md={3}>
          <div className="mb-3">
            <FormikInput
              label="* Matricula Secretaría"
              name="Matricula_SE"
              placeholder="Matricula"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        {/* Generación */}
        <Col md={3}>
          <div className="mb-3">
            <FormikInput
              label="* Generación"
              name="Generacion"
              placeholder="Generacion"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
      </Row>

      {/* Fecha Inscripción, Fecha Alta SE, Fecha Inicio de Clases */}
      <Row>
        {/* Fecha Inscripción */}
        <Col md={4}>
          <div className="mb-3">
            <FormikDatePicker
              label="Fecha Inscripción"
              name="Fecha_Inscripcion"
              placeholder="Selecciona tu Fecha Inscripción"
              dateFormat="Y-m-d"
              formik={formik}
            />
          </div>
        </Col>{" "}
        {/* Fecha Alta SE */}
        <Col md={4}>
          <div className="mb-3">
            <FormikDatePicker
              label="Fecha Inscripción Secretaría"
              name="Fecha_Inscripcion_SE"
              placeholder="Selecciona Fecha Inscripción ante Secretaría"
              dateFormat="Y-m-d"
              formik={formik}
            />
          </div>
        </Col>{" "}
        {/* Fecha Inicio de Clases */}
        <Col md={4}>
          <div className="mb-3">
            <FormikDatePicker
              label="Fecha Inicio Clases"
              name="Fecha_Inicio_Clases"
              placeholder="Selecciona tu Fecha Inicio Clases"
              dateFormat="Y-m-d"
              formik={formik}
            />
          </div>
        </Col>
      </Row>

      {/* CheckBoxes - Grado superior, Alta Oficial, Curso Propedéutico */}
      <Row>
        {/* Grado superior En_Proceso_Revalidacion_Materias */}
        <Col md={2}>
          <div className="mb-3"></div>
        </Col>{" "}
        {/* Alta Oficial - Es_Oficial*/}
        <Col md={2}>
          <div className="mb-3"></div>
        </Col>{" "}
        {/* Curso Propedéutico - Curso_Propedeutico*/}
        <Col md={2}>
          <div className="mb-3"></div>
        </Col>
      </Row>
    </>
  )
}

export default FormSectionAcademico
